export class BaseVendorAccountResultDto {
    id: number;
    accountNumber: string;
    description: string;
    active: boolean;
    eftActive: boolean;

    hasNotes: boolean;
    draftBankAccount: string;

    // Transient
    communityVendorId: number;
    vendorName: string;
}
